export default __webpack_public_path__ + "static/media/contract.51374308.png";